module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Regular.14820a12.ttf";